export default function () {
    async function post(params) {
        let error = null;
        try {
            await useApi().post('contact', params);
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    return {post};
}
